module.exports = __webpack_public_path__ + "img/Stemness-BRME_GSE179572.263b4d91.png";